/** Chrome Web Store install URL for the OverlayQA extension. Stable across surfaces. */
export const CWS_INSTALL_URL = 'https://chromewebstore.google.com/detail/overlayqa/pbnjikbncbjaaimelhlkfihgdkocmmei';
//# sourceMappingURL=cws.js.map